import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeftIcon } from "lucide-react";
import { H4 } from "@/components/ui/h4";
import { SelectorBackground } from "@/components/SelectorBackground";
import { PersonaHeader } from "@/components/PersonaHeader";
import { apiUrl } from "@/api/api";
import { H6 } from "@/components/ui/h6";
import { Persona } from "@/api/personas";

export function PersonaHeaderSection({
  className,
  personaData,
}: {
  className?: string;
  personaData: Pick<
    Persona,
    "persona_id" | "name" | "avatar_id" | "persona_video_avatar" | "gender"
  >;
}) {
  return (
    <div className={className}>
      <div className="relative w-full flex flex-row justify-center items-center">
        <Link
          className="absolute left-0"
          to={`/agents/${personaData.persona_id}`}
        >
          <Button
            className="hidden sm:flex flex-row gap-x-2"
            variant="ghost"
            color="primary"
          >
            <ChevronLeftIcon /> Back
          </Button>
        </Link>
        <H4 className="text-primary text-center font-medium py-4">
          Token Details
        </H4>
      </div>
      <div className="relative -z-10">
        <SelectorBackground className="absolute top-14" />
      </div>
      <PersonaHeader
        name={personaData.name ?? ""}
        imageSrc={`${apiUrl}/get-file?url=persona-knowledge-base/${
          personaData.persona_id
        }/${personaData.avatar_id}`}
        videoSrc={personaData.persona_video_avatar}
        gender={personaData.gender || "male"}
      >
        <H6 className="text-primary mt-2">{personaData.name}</H6>
      </PersonaHeader>
    </div>
  );
}
